import {
  ToastContainer,
  Message,
  CloseWrapper,
  ToastBackDrop,
  TryAgainButton,
} from "./Toast.styles";
import { Cancel01Icon } from "src/assets/icons/cancel-01";
import { CheckMarkCircle02Icon } from "src/assets/icons/checkmark-circle-02";

interface ToastProps {
  message: string;
  type?: "success" | "error";
  onClose: () => void;
  onTryAgain?: () => void;
  blurBackground?: boolean;
}

export default ({
  message,
  type = "success",
  onClose,
  onTryAgain,
  blurBackground,
}: ToastProps) => {
  return (
    <>
      {blurBackground && <ToastBackDrop />}
      <ToastContainer type={type}>
        {type === "success" && <CheckMarkCircle02Icon />}
        <Message>{message}</Message>
        {type === "error" && onTryAgain && (
          <TryAgainButton onClick={onTryAgain}>Try Again</TryAgainButton>
        )}

        <CloseWrapper type={type} onClick={onClose}>
          <Cancel01Icon />
        </CloseWrapper>
      </ToastContainer>
    </>
  );
};
